import I18n from 'components/I18n'
import { TagType } from 'components/Tag'
import Text from 'components/Text'
import { actions } from 'data'
import { SingleProductEligibility } from 'data/Eligibility/types'
import { Bank } from 'data/Payments/BankTransfer/types'
import { BeneficiaryType } from 'data/types'
import messages from 'lang'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import _Rows, { RowItemType } from 'scenes/Cashflow/Rows'
import styled from 'styled-components'

import EligibilityNotifications from '../EligibilityNotifications'
import LinkBank from '../LinkBank'
import { BodyTitle, ModalContainer } from '../styles'

const Rows = styled(_Rows)`
  padding-bottom: 2rem;
`

type Props = {
  banks: Bank[]
  beneficiaries: BeneficiaryType[]
  canBankTransfer: boolean
  currency: string
  eligibility: SingleProductEligibility
  isWithdraw: boolean
  onBack: () => void
  onSelectBank: (bank: Bank) => void
  onSelectBeneficiary: (beneficiary: BeneficiaryType) => void
  onWireTransfer: () => void
}
const TargetOptions = ({
  banks,
  beneficiaries,
  canBankTransfer,
  currency,
  eligibility,
  isWithdraw,
  onBack,
  onSelectBank,
  onSelectBeneficiary,
  onWireTransfer
}: Props) => {
  const intl = useIntl()
  const [linkNewBank, setLinkNewBank] = useState(false)
  const dispatch = useDispatch()

  const beneficiaryOptions = beneficiaries.map((beneficiary) => ({
    onClick: () => onSelectBeneficiary(beneficiary),
    symbol: beneficiary.address,
    tags: [{ copy: messages.wire_fee, key: 'wire_fee', type: TagType.DEFAULT }],
    title: beneficiary.name,
    type: 'bank'
  }))

  const bankOptions = banks.map((bank: Bank) => ({
    onClick: () => onSelectBank(bank),
    symbol: bank.id,
    tags: [{ copy: messages.free, key: 'free', type: TagType.SUCCESS }],
    title: bank?.details?.bankName,
    type: 'bank'
  }))

  const rows: RowItemType[] = [...beneficiaryOptions, ...bankOptions]

  rows.push({
    label: intl.formatMessage(messages.available_later),
    onClick: () => onWireTransfer(),
    symbol: 'wire',
    title: intl.formatMessage(currency === 'USD' ? messages.wire_transfer : messages.bank_transfer),
    tooltip: 'wire_transfer_disclaimer',
    type: 'wire'
  })

  if (canBankTransfer) {
    rows.push({
      label: '',
      onClick: () => {
        setLinkNewBank(true)
        dispatch(actions.analytics.trackEvent({ key: 'Add Bank Clicked', properties: {} }))
      },
      symbol: 'add-bank',
      tight: true,
      title: intl.formatMessage(messages.add_new_bank),
      type: 'add'
    })
  }

  if (!eligibility.enabled) {
    return (
      <EligibilityNotifications
        context={isWithdraw ? 'WITHDRAW' : 'DEPOSIT'}
        reason={eligibility.reasonNotEligible}
      />
    )
  }

  if (linkNewBank) {
    return (
      <ModalContainer>
        <LinkBank
          showWrapper={false}
          currency={currency}
          onBack={() => {
            onBack()
            setLinkNewBank(false)
          }}
          onSuccess={onSelectBank}
        />
      </ModalContainer>
    )
  }

  return (
    <ModalContainer>
      <BodyTitle>
        <Text weight={600} textTransform='capitalize' size='lg' color='white'>
          <I18n data={isWithdraw ? messages.withdraw_via_bank : messages.deposit_via_bank} />
        </Text>
      </BodyTitle>
      <Rows rows={rows} />
    </ModalContainer>
  )
}

export default TargetOptions
